module.exports = __webpack_public_path__ + "assets/img/2061591928118_.pic_hd.24d16a21.jpg";